import { axiosEduServer } from "../utils/configAxios";

export const registrarPlazoNotas = (data) =>
  axiosEduServer.post("/plazonotas", data).then(({ data }) => data);

export const getAllPlazoNotas = () =>
  axiosEduServer.get("/plazonotas").then(({ data }) => data);

// Endpoint para docentes: verificar si tienen plazo activo
export const verificarPlazoActivo = (idGrupo) =>
  axiosEduServer.get(`/plazonotas/verificar/${idGrupo}`).then(({ data }) => data);

export const eliminarPlazoNotas = (id) =>
  axiosEduServer.delete(`/plazonotas/${id}`).then(({ data }) => data);

export const actualizarPlazoNotas = (id, data) =>
  axiosEduServer.put(`/plazonotas/${id}`, data).then(({ data }) => data).catch((err) => { throw err;});